<template>
    <common-dropdown :isOpen="true" :hasArrow="false" arrowPositionY="bottom" arrowPositionX="right">
        <common-progress :percentage="profilePercentage" :isBarHidden="false" :isRounded="false"></common-progress>
        <common-content-spacer class="complete-profile-reminder__rating" height="micro">
            <p class="complete-profile-reminder__rating-percentage">
                {{ $t('elements.home.profile_reminder.percentage', { profilePercentage }) }}
            </p>
            <div style="positon: relative">
                <div class="complete-profile-reminder__circle"></div>
                <b class="complete-profile-reminder__rating-text-bold">
                    {{ $t('elements.home.profile_reminder.improve_rating') }}
                </b>
            </div>
            <div class="complete-profile-reminder__rating-text">
                <router-link :to="{ name: 'profile' }" class="complete-profile-reminder__rating-link">
                    {{ $t('elements.home.profile_reminder.complete_profile') }}
                </router-link>
                <p>{{ $t('elements.home.profile_reminder.increase_chances') }}</p>
            </div>
        </common-content-spacer>
    </common-dropdown>
</template>

<script>
    export default {
        data() {
            return {
                profilePercentage: 80,
            }
        },
    }
</script>
